export const ROLE_TAB_MAP = {
  "school-admin": ["all", "specificStudent", "specificTeacher", "allParent"],
  teacher: ["all", "specificStudent", "allParent"],
  accounts: ["all", "specificStudent", "specificTeacher", "allParent"],
  principal: ["all", "specificStudent", "specificTeacher", "allParent"],
};

export const ROLE_CONFIG = {
  "school-admin": {
    notification: {
      create: "/school-admin/notification/create",
      list: "/school-admin/notification",
      view: "/school-admin/notification/detail",
    },
    announcement: {
      create: "/school-admin/announcement/create",
    },
  },

  accounts: {
    notification: {
      create: "/school-admin/notification/create",
      list: "/school-admin/notification",
      view: "/school-admin/notification/detail",
    },
    announcement: {
      create: "/school-admin/announcement/create",
    },
  },

  principal: {
    notification: {
      create: "/school-admin/notification/create",
      list: "/school-admin/notification",
      view: "/school-admin/notification/detail",
    },
    announcement: {
      create: "/school-admin/announcement/create",
    },
  },

  teacher: {
    notification: {
      create: "/teacher/notification/create",
      list: "/teacher/notification",
      view: "/teacher/notification/detail",
    },
  },
};
